




























import { Mutations } from '@/ts/store/Constants';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class SidebarImageUpload extends Vue {
    public base64ImageData: string = '';
    public fileName: string = '';

    constructor() {
        super();
    }

    get activeVariantId(): any {
        return this.$store.getters['Variants/getVariantId'];
    }

    get getFloorPlan() {
        return this.$store.getters['User/getFloorPlanBase64'];
    }

    get loadFloorPlan() {
        if (this.getFloorPlan !== '') {
            return true;
        } else {
            return false;
        }
    }

    public loadImageOrNot() {
        if (this.base64ImageData !== '') {
            return true;
        } else {
            return false;
        }
    }

    public loadTextOrNot() {
        if (this.base64ImageData === '') {
            return true;
        } else {
            return false;
        }
    }

    public picker() {
        const element: HTMLElement = document.getElementById('hococo-floor-plan-image-picker') as HTMLElement;
        element.click();
    }

    public handleImageUpload(event: any) {
        const element = (this.$refs.imageInputElement as HTMLInputElement);
        if (element.files.length === 0) {
            return;
        }
        const file = (element.files[0] as File);

        // convert to base64
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.fileName = file.name;
            this.base64ImageData = reader.result.toString();
            this.selectImage();
        };
    }

    public selectImage() {
        if (this.base64ImageData !== '' && this.base64ImageData !== null && this.fileName !== '' && this.fileName !== null ) {
            this.$store.commit(Mutations.SAVE_FLOOR_PLAN_BASE64_IMAGE_DATA, {
                fileName: this.fileName,
                base64: this.base64ImageData,
            });

            this.$store.commit(Mutations.EDIT_FLOOR_PLAN);
        } else {
            return;
        }
    }

}
